"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIAvatarMultiOrSingle = _interopRequireDefault(require("./UIAvatarMultiOrSingle"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Constants = require("./Constants");

var avatarSizeBackwardsCompat = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
}; // This file is now just going to absorb the API changes from v1 to
// v2 so we can be waaaay cleaner down the line

var UIAvatar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIAvatar, _Component);

  function UIAvatar() {
    (0, _classCallCheck2.default)(this, UIAvatar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAvatar).apply(this, arguments));
  }

  (0, _createClass2.default)(UIAvatar, [{
    key: "companyWithWarning",
    value: function companyWithWarning(company) {
      if (company) {
        _devLogger.default.warn({
          message: 'there is no company prop, maybe you mean domain or companyId'
        });
      }
    }
  }, {
    key: "sizeWithWarning",
    value: function sizeWithWarning(size) {
      var checkedAvatarSize = avatarSizeBackwardsCompat[size];

      if (checkedAvatarSize) {
        _devLogger.default.warn({
          message: 'Old size prop values are supplied, please use 2 letter sizes instead'
        });

        return checkedAvatarSize;
      }

      return size;
    }
  }, {
    key: "lookupWithWarning",
    value: function lookupWithWarning(lookup, lookups, avatarLookup) {
      var oldLookup = lookups || avatarLookup;

      if (oldLookup) {
        _devLogger.default.warn({
          message: 'lookups and avatarLook up deprecated props, please just use lookup'
        });

        return lookup || oldLookup;
      }

      return lookup;
    }
  }, {
    key: "hubSpotUserEmailWithWarning",
    value: function hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail) {
      if (hubspotUserEmail) {
        _devLogger.default.warn({
          message: 'I think you meant hubSpotUserEmail (S vs s)'
        });
      }

      return hubSpotUserEmail || hubspotUserEmail;
    }
  }, {
    key: "maxAvatarsWithWarning",
    value: function maxAvatarsWithWarning(maxAvatars, totalNumOfAvatars) {
      if (totalNumOfAvatars) {
        _devLogger.default.warn({
          message: 'totalNumOfAvatars is deprecated, please use maxAvatars instead'
        });

        return maxAvatars || totalNumOfAvatars;
      }

      return maxAvatars;
    }
  }, {
    key: "catchWeirdProps",
    value: function catchWeirdProps() {
      var _this$props = this.props,
          _isHoverlayOpen = _this$props._isHoverlayOpen,
          _isHasTooltip = _this$props._isHasTooltip,
          _toolTipOverWrite = _this$props._toolTipOverWrite,
          _noDefaultSrc = _this$props._noDefaultSrc,
          _truncateAvatarListInTooltip = _this$props._truncateAvatarListInTooltip,
          avatarLookup = _this$props.avatarLookup,
          avatarType = _this$props.avatarType,
          childClassName = _this$props.childClassName,
          children = _this$props.children,
          childStyles = _this$props.childStyles,
          className = _this$props.className,
          companyId = _this$props.companyId,
          displayName = _this$props.displayName,
          company = _this$props.company,
          domain = _this$props.domain,
          email = _this$props.email,
          existsInPortal = _this$props.existsInPortal,
          fetchAvatars = _this$props.fetchAvatars,
          fileManagerKey = _this$props.fileManagerKey,
          hasMoreHref = _this$props.hasMoreHref,
          href = _this$props.href,
          hubspotUserEmail = _this$props.hubspotUserEmail,
          hubSpotUserEmail = _this$props.hubSpotUserEmail,
          isHoverlay = _this$props.isHoverlay,
          lookup = _this$props.lookup,
          lookups = _this$props.lookups,
          maxAvatars = _this$props.maxAvatars,
          onClick = _this$props.onClick,
          productId = _this$props.productId,
          portalId = _this$props.portalId,
          size = _this$props.size,
          socialNetwork = _this$props.socialNetwork,
          src = _this$props.src,
          style = _this$props.style,
          toolTipPlacement = _this$props.toolTipPlacement,
          totalNumOfAvatars = _this$props.totalNumOfAvatars,
          type = _this$props.type,
          textSpacing = _this$props.textSpacing,
          truncateLength = _this$props.truncateLength,
          vid = _this$props.vid; // avatarRenderer
      // backgroundcolor
      // color
      // name …only social is using UIAvatarIcon and that's depricated now.
      // https://private.hubteamqa.com/opengrok/search?q=%22%3CUIAvatarIcon%22&defs=&refs=&path=&hist=&type=&project=all
      // Shape
      // Warnings
      // size needs to be
      // lookups
      // avatarLookup

      return {
        _isHoverlayOpen: _isHoverlayOpen,
        _isHasTooltip: _isHasTooltip,
        _toolTipOverWrite: _toolTipOverWrite,
        _noDefaultSrc: _noDefaultSrc,
        _truncateAvatarListInTooltip: _truncateAvatarListInTooltip,
        childClassName: childClassName,
        children: children,
        childStyles: childStyles,
        className: className,
        company: this.companyWithWarning(company),
        companyId: companyId,
        displayName: displayName,
        domain: domain,
        email: email,
        existsInPortal: existsInPortal,
        fetchAvatars: fetchAvatars,
        fileManagerKey: fileManagerKey,
        hasMoreHref: hasMoreHref,
        href: href,
        hubSpotUserEmail: this.hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail),
        isHoverlay: isHoverlay,
        lookup: this.lookupWithWarning(lookup, lookups, avatarLookup),
        maxAvatars: maxAvatars || totalNumOfAvatars,
        onClick: onClick,
        productId: productId,
        portalId: portalId,
        size: this.sizeWithWarning(size),
        socialNetwork: socialNetwork,
        src: src,
        style: style,
        type: type || avatarType,
        textSpacing: textSpacing,
        truncateLength: truncateLength,
        vid: vid,
        toolTipPlacement: toolTipPlacement
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIAvatarMultiOrSingle.default, this.catchWeirdProps(this.props));
    }
  }]);
  return UIAvatar;
}(_react.Component);

UIAvatar.propTypes = {
  lookups: _react.PropTypes.any,
  avatarLookup: _react.PropTypes.any,
  totalNumOfAvatars: _react.PropTypes.number,
  avatarType: _react.PropTypes.string,
  _truncateAvatarListInTooltip: _react.PropTypes.bool,
  _isHoverlayOpen: _react.PropTypes.bool,
  _isHasTooltip: _react.PropTypes.bool,
  _toolTipOverWrite: _react.PropTypes.bool,
  _noDefaultSrc: _react.PropTypes.bool,
  authed: _react.PropTypes.bool,
  childClassName: _react.PropTypes.string,
  children: _react.PropTypes.node,
  childStyles: _react.PropTypes.object,
  className: _react.PropTypes.string,
  company: _react.PropTypes.string,
  companyId: _react.PropTypes.number,
  displayName: _react.PropTypes.string,
  domain: _react.PropTypes.string,
  email: _react.PropTypes.string,
  existsInPortal: _react.PropTypes.bool,
  fetchAvatars: _react.PropTypes.func,
  fileManagerKey: _react.PropTypes.string,
  hasMoreHref: _react.PropTypes.string,
  href: _react.PropTypes.string,
  hubspotUserEmail: _react.PropTypes.string,
  hubSpotUserEmail: _react.PropTypes.string,
  isHoverlay: _react.PropTypes.bool,
  lookup: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.array]),
  maxAvatars: _react.PropTypes.number,
  onClick: _react.PropTypes.func,
  productId: _react.PropTypes.number,
  portalId: _react.PropTypes.number,
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  socialNetwork: _react.PropTypes.string,
  src: _react.PropTypes.string,
  style: _react.PropTypes.object,
  toolTipPlacement: _react.PropTypes.string,
  type: _react.PropTypes.string,
  textSpacing: _react.PropTypes.number,
  truncateLength: _react.PropTypes.number,
  vid: _react.PropTypes.number
};
var _default = UIAvatar;
exports.default = _default;
module.exports = exports.default;